import { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";

import {
  isTokenExpired,
  isUserGuest,
  redirectToCorrectLocation,
  setupClient,
  setupCountry,
} from "../../utils/authentication";
import { WfpManagerHeader } from "../WfpManagerHeader";
import { FullscreenLoading } from "../../components/FullscreenLoading";
import { ensureSelectedCountry } from "../../utils/countryStorage";
import { GuestRouteProps } from "./types";

type AuthStatus = "loading" | "loggedIn" | "loggedOut";

// Route guard for /guest/* paths. Auth is evaluated once on mount.
export const GuestRoute = ({
  component: Component,
  path,
  exact,
  fullScreen = false,
}: GuestRouteProps) => {
  const history = useHistory();
  const [status, setStatus] = useState<AuthStatus>("loading");

  useEffect(() => {
    const ciamAccessToken = localStorage.getItem("ciam_access_token");
    const userProfile = localStorage.getItem("user_profile");
    const selectedCountry = ensureSelectedCountry();
    const expiryDate = new Date(localStorage.getItem("expiry_date") ?? 0);

    if (!ciamAccessToken || !userProfile || isTokenExpired(expiryDate)) {
      setStatus("loggedOut");
      history.push("/login");
    } else if (!isUserGuest(userProfile)) {
      redirectToCorrectLocation(userProfile, history);
    } else {
      setupClient(ciamAccessToken);
      if (selectedCountry) {
        setupCountry(selectedCountry);
      }
      setStatus("loggedIn");
    }
  }, [history]);

  if (status === "loggedIn") {
    const route = <Route key={path} exact={exact} path={path} component={Component} />;

    if (fullScreen) {
      return route;
    }

    return (
      <div>
        <WfpManagerHeader>{route}</WfpManagerHeader>
      </div>
    );
  }

  return <FullscreenLoading isVisible />;
};
